import React from 'react';
import {ButtonPriority} from '@wix/wix-ui-tpa';
import {Button, Dropdown, Text, TextField, TextPriority} from '@wix/wix-ui-tpa/cssVars';
import {useTranslation} from '@wix/yoshi-flow-editor';
import s from './InlineAddressForm.scss';

export enum InlineAddressFormDataHook {
  Root = 'InlineAddressForm.Root',
  Title = 'InlineAddressForm.Title',
  CountryDropdown = 'InlineAddressForm.CountryDropdown',
  SubdivisionDropdown = 'InlineAddressForm.SubdivisionDropdown',
  PostalCodeField = 'InlineAddressForm.PostalCodeField',
  Action = 'InlineAddressForm.Action',
}

type InlineAddressFormProps = {
  onClose: () => void;
};

export const InlineAddressForm = ({onClose}: InlineAddressFormProps) => {
  const {t} = useTranslation();

  return (
    <div className={s.root} data-hook={InlineAddressFormDataHook.Root}>
      <Text priority={TextPriority.primary} data-hook={InlineAddressFormDataHook.Title}>
        {t('cart.change_region_modal.title')}
      </Text>

      <div className={s.fields}>
        <Dropdown
          data-hook={InlineAddressFormDataHook.CountryDropdown}
          options={[]}
          upgrade={true}
          label={t('cart.change_region_modal.country_label')}
        />

        <Dropdown
          data-hook={InlineAddressFormDataHook.SubdivisionDropdown}
          options={[]}
          upgrade={true}
          label={'**** Subdivision Placeholder ****'}
        />

        <TextField
          data-hook={InlineAddressFormDataHook.PostalCodeField}
          className={s.textField}
          label={t('cart.change_region_modal.zip_label')}
        />
      </div>

      <Button
        priority={ButtonPriority.basic}
        data-hook={InlineAddressFormDataHook.Action}
        fullWidth
        upgrade={true}
        onClick={onClose}>
        {t('cart.change_region_modal.update')}
      </Button>
    </div>
  );
};
